import { allEngineMetricNames } from '@shared_types/metrics/engine_metrics'
import { initializeMetrics } from '@shared_utils/metric_utils'

import { LOAD_ENGINES, UPDATE_ENGINES } from '../actions'

const initialState = initializeMetrics(allEngineMetricNames)

// @TODO fix types
export default function init (previousState = initialState, { type, payload }: { type: string; payload: unknown }) {
  if (type === LOAD_ENGINES || type === UPDATE_ENGINES) {
    console.log('init engines', payload)
    return Object.assign({}, previousState, payload)
  } else {
    return previousState
  }
}
